import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import styles from './Login.module.css';
import logo from '../../assets/thuto_mdm-logo.svg';
import { useAuth } from '../../context/AuthContext';

const BASE = process.env.PUBLIC_URL || '';
const supportsWebP = typeof document !== 'undefined' &&
  document.createElement('canvas').toDataURL('image/webp').startsWith('data:image/webp');
const BG = `linear-gradient(#00000087,#00000087), url('${BASE}/images/${supportsWebP ? 'green-background.webp' : 'green-background.jpg'}')`;


function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/overview');
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={`${styles.pageWrapper} d-flex align-items-center justify-content-center`} style={{ backgroundImage: BG }}>
      <div className={`${styles.card} container-sm`}>

        <div className={styles.logoWrapper}>
          <img src={logo} alt="Thuto MDM" className={styles.logo} />
        </div>

        <h1 className={styles.heading}>Sign into your account</h1>

        {error && <div className={styles.errorMsg}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className={`${styles.label} form-label`}>Email or username</label>
            <input
              type="text"
              className={`form-control ${styles.input}`}
              placeholder="Enter email or username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />
          </div>

          <div className="mb-2">
            <label className={`${styles.label} form-label`}>Password</label>
            <div className={`${styles.passwordWrapper}`}>
              <input
                type={showPassword ? 'text' : 'password'}
                className={`form-control ${styles.input}`}
                placeholder="Enter password"
                style={{ paddingRight: '2.2rem' }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className={styles.eyeBtn}
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <AiOutlineEyeInvisible size={18} /> : <AiOutlineEye size={18} />}
              </button>
            </div>
            <a href="/forgot-password" className={styles.forgotLink}>Forgot password?</a>
          </div>

          <div className="mt-4">
            <button type="submit" className={`btn w-100 ${styles.loginBtn}`} disabled={loading}>
              {loading ? 'Signing in…' : 'Login'}
            </button>
          </div>
        </form>

      </div>
    </div>
  );
}

export default Login;
